// extracted by mini-css-extract-plugin
export default {"DividerLiner":"Divider_DividerLiner__14gJC","titleHolder":"Divider_titleHolder__kA8+D"};